<template>
	<div>
		<vs-row>
			<vx-card title="Dropship bestellingen">
				<div v-if="!orders || orders.length === 0">
					<div class="vx-col w-full mb-base text-center">
						<font-awesome-icon :icon="['fas', 'check-double']" class="fa-icon fa-orders-none-found" />
						<h1 class="orders-none-found">Je hebt geen openstaande dropship bestellingen</h1>
					</div>
				</div>

				<div v-else>
					<div class="vx-col pt-2 pb-2">
						<div class="flex flex-wrap">
							<div class="mr-2">
								<vx-input-group>
									<template slot="prepend">
										<div class="prepend-text bg-primary">
											<span>Bestelnummer</span>
										</div>
									</template>
									<vs-input placeholder="Zoeken" v-model="search" />
								</vx-input-group>
								<div class="text-xs text-right" v-if="amount > 0">
									{{ amount }} bestellingen gevonden
								</div>
							</div>
						</div>
					</div>

					<vs-table :data="orders">
						<vs-tr>
							<vs-th></vs-th>
							<vs-th>Bestelnummer</vs-th>
							<vs-th>Dropship referentie</vs-th>
							<vs-th>Klant</vs-th>
							<vs-th colspan="2">Verzenden</vs-th>
						</vs-tr>
						<vs-tr :key="order.order.id" v-for="order in this.orders">
							<td>
								<div class="flex float-left">
								<img v-if="order.order.type === 1" src="@/assets/images/orders/types/bol.png" alt="content-img" style="max-height: 40px">
								<img v-if="order.order.type === 2" src="@/assets/images/orders/types/lightspeed.png" alt="content-img" style="max-height: 40px">
								</div>
								<div class="flex float-left pl-5">
									<order-status :order="order" :show-drop-shipping="false" />
								</div>
							</td>
							<td>
								{{ order.order.type_id_visible }}
							</td>
							<td v-if="order.order.dropship_reference !== null">
								{{ order.order.dropship_reference }}
							</td>
							<td v-else>
								-
							</td>
							<td>
								{{ order.shipping.full_name }}
							</td>
							<td>
								<vs-button id="downloadPackingSlipsButton" class="vs-con-loading__container" color="primary"
										   @click="openShipOrderPrompt(order)">
									<font-awesome-icon :icon="['fas', 'truck']" class="fa-icon" />
								</vs-button>
							</td>
							<td class="cursor-pointer" @click="openInfoScreen(order)">
								<font-awesome-icon :icon="['fas', 'info-circle']" size="2x" />
							</td>
						</vs-tr>
					</vs-table>

					<div class="vx-row justify-center mt-5">
						<div class="vx-col">
							<vs-pagination :total="maxPages" v-model="page"></vs-pagination>
						</div>
					</div>
				</div>
			</vx-card>
		</vs-row>

		<vs-popup :fullscreen="true" :title="`Bestelling overzicht #${infoScreen.visible? infoScreen.order.order.type_id_visible : ''}`" :active.sync="infoScreen.visible">
			<order-details-popup :order="infoScreen.order" v-if="infoScreen.visible" :dymo-printer="dymoPrinter" />
		</vs-popup>

		<vs-prompt
			@accept="shipOrderAccept"
			:active.sync="shipOrderPrompt.visible"
			title="Bestelling verzenden"
			acceptText="Verzend"
			cancelText="Annuleren">
			<form data-vv-scope="shippingForm">
				<div class="vx-row">
					<div class="vx-col w-full">
						<label class="multiselect-label">Selecteer verzendmethode</label>
						<vue-multiselect
							placeholder="Verzendmethode"
							v-model="shipOrderPrompt.shippingMethod"
							:options="shipOrderPrompt.options"
							:show-labels="false"
							:allow-empty="false"
							label="text"
						/>
					</div>

					<div class="vx-col w-full">
						<vs-input label="Track & trace nummer" v-model="shipOrderPrompt.tracking" />
					</div>
				</div>
			</form>
		</vs-prompt>
	</div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate';
import apiClient from '@/services/apiClient';
import dymoPrinter from '@/services/dymo/dymoPrinter';
import OrderDetailsPopup from '@/views/orderDetails/orderDetailsPopup';
import OrderStatus from '@/views/orders/components/status';

Vue.use(VeeValidate);
const messages = {
	custom: {
		shippingMethod: {
			required: 'Dit veld is verplicht',
		}
	}
};
Validator.localize('en', messages);

export default {
	name: 'orderDropship',
	components: {
		OrderStatus,
		OrderDetailsPopup
	},
	data() {
		return {
			orders: [],
			amount: 0,
			orderSort: 'dateNewOld',
			search: '',
			page: 1,
			page_size: 10,
			maxPages: 0,
			infoScreen: {
				visible: false,
				order: null,
			},
			shipOrderPrompt: {
				visible: false,
				order: null,
				shippingMethod: null,
				tracking: '',
				options: [],
			},
			dymoPrinter: new dymoPrinter(),
		}
	},
	computed: {
		shippingOptions() {
			return this.$store.state.sendOptions.deliveryOptions;
		}
	},
	mounted() {
		this.$vs.loading();
		this.getOrders();

		this.$store.dispatch('sendOptions/init').then(response => {
			for (const shippingOption in this.shippingOptions) {
				if (this.shippingOptions.hasOwnProperty(shippingOption)) {
					if (this.shippingOptions[shippingOption]) {
						this.shipOrderPrompt.options.push({
							text: this.getShippingOptionName(shippingOption),
							value: shippingOption
						})
					}
				}
			}
		});

		this.dymoPrinter.init();
	},
	watch: {
		'orderSort'(newSort) {
			this.sortHistoryChange(newSort);
		},
		'search'(newSearch) {
			this.changeSearch(newSearch);
		},
		'page'(newPage) {
			this.changePage(newPage);
		}
	},
	methods: {
		getOrders() {
			this.$store.dispatch('orderDropship/init',
				{
					sort_by: this.orderSort,
					search: this.search,
					page_size: this.page_size,
					page: this.page
				}).then(res => {
				this.orders = this.$store.state.orderDropship.orderDropship.orders;
				this.amount = this.$store.state.orderDropship.orderDropship.amount;

				this.maxPages = Math.ceil(this.amount / this.page_size);
				this.$vs.loading.close();
			}).catch(err => {
				this.$vs.loading.close();
			});
		},
		openInfoScreen(order) {
			this.infoScreen.order = order;
			this.infoScreen.visible = true;
		},
		sortHistoryChange(orderSort) {
			this.orderSort = orderSort;

			this.getOrders();
		},
		changeSearch(search) {
			this.search = search;

			this.getOrders();
		},
		changePageSize(pageSize) {
			this.page_size = pageSize;

			this.getOrders();
		},
		changePage(page) {
			this.page = page;

			this.getOrders();
		},
		openShipOrderPrompt(order) {
			this.shipOrderPrompt.order = order;
			this.shipOrderPrompt.visible = true;
		},
		shipOrderAccept() {
			this.$validator.validateAll('shippingForm').then(result => {
				if (!result) {
					this.shipOrderPrompt.visible = true;

					this.$vs.notify({
						title: 'Oops!',
						text: 'Er zitten fouten in het formulier.',
						color: 'danger'
					});

					return;
				}

				const params = {
					order_id: this.shipOrderPrompt.order.id,
					ship: true,
					transporter_code: this.shipOrderPrompt.shippingMethod.value,
				};

				if (this.shipOrderPrompt.tracking !== '') {
					params.track_and_trace = this.shipOrderPrompt.tracking;
				}

				apiClient.put('orders/update', params).then(response => {
					this.getOrders();
					this.clearShipOrderPromptData();
				}).catch(error => {
					this.$vs.notify({
						title: 'Oops!',
						text: 'Het verzenden van bestelling #' + this.shipOrderPrompt.order.order.type_id_visible + ' is mislukt',
						color: 'danger'
					});
				});

			});
		},
		clearShipOrderPromptData() {
			this.shipOrderPrompt.visible = false;
			this.shipOrderPrompt.order = null;
			this.shipOrderPrompt.shippingMethod = null;
			this.shipOrderPrompt.tracking = '';
		},
		getShippingOptionName(shippingOption) {
			const shippingOptions = {
				BRIEFPOST: 'Briefpost',
				UPS: 'UPS',
				TNT: 'PostNL',
				TNT_EXTRA: 'PostNL extra@home',
				TNT_BRIEF: 'PostNL Briefpost',
				TNT_EXPRESS: 'TNT Express',
				DYL: 'Dynalogic',
				DPD_NL: 'DPD Nederland',
				DPD_BE: 'DPD België',
				BPOST_BE: 'Bpost België',
				BPOST_BRIEF: 'Bpost Briefpost',
				DHLFORYOU: 'DHLFORYOU',
				GLS: 'GLS',
				FEDEX_NL: 'FedEx Nederland',
				FEDEX_BE: 'FedEx Belgie',
				OTHER: 'Anders',
				DHL: 'DHL',
				DHL_DE: 'DHL Germany',
				DHL_GLOBAL_MAIL: 'DHL Global mail',
				TSN: 'Transportservice Nederland',
				FIEGE: 'Fiege',
				TRANSMISSION: 'TransMission',
				PARCEL_NL: 'Parcel.nl',
				LOGOIX: 'LogoiX',
				PACKS: 'Packs',
				COURIER: 'Bezorgafspraak',
				RJP: 'NedWRK(Red je pakketje)',
			};

			return shippingOptions[shippingOption];
		},
	}
}
</script>
<style>
.fa-orders-none-found {
	color: rgb(var(--vs-primary), 0.1);
	font-size: 20em;
	margin-top: 2vh;
	margin-bottom: 2vh;
}

h1.orders-none-found {
	color: rgb(var(--vs-primary), 0.1);
}
</style>